import $ from 'jquery';
import modaal from 'modaal';
import ScrollMagic from 'scrollmagic';

import { ViewPort } from '../utils/constants';
import Util from '../utils/ui';

const getCurrentYear = () => {
  const year = new Date().getFullYear();
  return `${year} © All Rights Reserved.`;
};

const isDesktop = () =>  Util.getViewPort() === ViewPort.Desktop;

class Layout {
	constructor() {
		this.$body = $('body');
		this.$header = $('.header');
		this.controller = new ScrollMagic.Controller();

		this.$primaryNavItem = $('.nav-list > li');
    this.timer = 0;
    this.scrollTimer = null;
    this.lastScrollTop = 0;
		this.delta = 5;
	}

  init() {
    this.bindNavEvents();
    this.bindModalEvents();
		this.scrollElementUp();
    $('#copyright').text(getCurrentYear());
  }

  bindModalEvents() {
    $('.modaal-image').modaal({ type: 'image' });
    $('.modaal-video').modaal({ type: 'video' });
    window.modaalSetup = true;
  }

  bindNavEvents() {
		// Hide Header on on scroll down
		$(window).on('scroll', e => {
      if (this.scrollTimer == null) {
        this.scrollTimer = 1;
        setTimeout(() => {
          this.hasScrolled();
          this.scrollTimer = null;
        }, 100);
      }
		});

    // top nav hamburger
		$('button.nav-toggle').on('click', e => {
        e.stopPropagation();
        this.toggleMainNav(e);
    });

    // open megamenu on hover for desktop
		this.$primaryNavItem.on('mouseover', e => {
      if (!isDesktop()) return;
			clearTimeout(this.timer);
			$('.nav-submenu').removeClass('open');
			this.openSubmenu(e);
		}).on('mouseleave', e => {
      if (!isDesktop()) return;
			this.timer = setTimeout(() => {
				this.closeSubmenu(e);
			}, 300);
		}).on('click', e => {
      if (isDesktop()) return;
			clearTimeout(this.timer);
			this.toggleSubmenu(e);
    });
  }

  hasScrolled() {
		let st = $(window).scrollTop();
		let headerHeight = $('.header').outerHeight();

		// Make sure they scroll more than delta
		if (Math.abs(this.lastScrollTop - st) <= this.delta) {
			return;
		}

		// If they scrolled down and are past the header, add class .header-up.
		// This is necessary so you never see what is "behind" the header.
		if (st > headerHeight * 1.1) {
			this.$body.css('padding-top', headerHeight);

			if (st > this.lastScrollTop) {
				// Scroll Down
				this.$body.removeClass('header-down').addClass('header-up');
				this.$header.css('top', -headerHeight);
			}
			else if (st + $(window).height() < $(document).height()) {
				// Scroll Up
				this.$body.removeClass('header-up').addClass('header-down');
				this.$header.css('top', 0);
			}
		}
		else if (st <= (50)) {
			this.$body.css('padding-top', 0);
			this.$header.css('top', 'auto');
			this.$body.removeClass('header-up').removeClass('header-down');
		}

		this.lastScrollTop = st;
	}

  openSubmenu(e) {
		const target = $(e.currentTarget);
		$(target).find('.nav-submenu').addClass('open');
    return target;
	}

  closeSubmenu(e) {
		const target = $(e.currentTarget);
		$(target).find('.nav-submenu').removeClass('open');
    return target;
	}

  toggleSubmenu(e) {
		const target = $(e.currentTarget);
		$(target).find('.nav-submenu').toggleClass('open');
    return target;
	}

  toggleMainNav() {
		$('.nav-wrapper').toggleClass('open');
		this.$body.toggleClass('nav-open');
  }

  scrollElementUp() {
		let revealElements = document.querySelectorAll('.scroll-element-up,.scroll-element-left');

		[...revealElements].forEach((element, index) => {
      const offset = $(element).data('offset') ?? '150';

			new ScrollMagic.Scene({
				triggerElement: element,
				offset: parseInt(offset, 10),
				triggerHook: 5,
				reverse: false,
			})
				.setClassToggle(element, 'visible') // add class toggle
				.addTo(this.controller);
		});
	}
}

export default Layout;
